<template>
  <b-card>
    <b-card-title class="title">{{$t('label_auditReports_requirements_generalSummary_title')}}</b-card-title>
    <p class="card-text mb-0">
      {{ $t("label_auditReports_requirements_generalSummary_description") }}
    </p>
    <div v-if="backButtom" class="up">
      &larr;
      {{ $t("label_reports_genderGap_generalSummary_outlook_up_buttom") }}
    </div>
    <div :id="alias" class="feature" :style="{ height: height }" />
    <div class="convention-container ">
      <h4 class="convention-title">{{$t('label_evaluation_treemap_conventions_title')}}: </h4>
<ul class="conventions">
  <il class="convention" v-for="(convention,index) in conventions" :key="index">
    <span class="convention-color" :style="'background-color: '+convention.color "></span>
    <span class="convention-text">{{$t(convention.label)}}</span>
  </il>
</ul>
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";
import { EvaluationChartTreemap } from "@/utils/ChartTreemap";

// https://codepen.io/anon/pen/JejGxW

export default {
  name: "CardEvaluationChartTreemap",
  props: {
    evaluation: {
      type: Object,
      default: () => {}
    },
    alias: {
      type: String,
      default: "treemapId",
    },
    height: {
      type: String,
      default: "600px",
    },
    backButtom: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      conventions: []
    };
  },
  watch: {
    evaluation: function () {
      this.createTreemap();
    },
    getReportConventionLevel: function (newVale){
      this.setConventions(newVale)
    }
  },
  computed: mapGetters(["getReportConventionLevel"]),
  mounted() {
    this.setConventions('branch')
    console.log("Mounted");
    // This let update the graphic when the language change
    this.unsubscribe = this.$store.subscribe((mutation) => {
      switch (mutation.type) {
        case "SET_LANG":
          var svg = this.$d3.select("#" + this.alias);
          svg.selectAll(".node").remove();
          this.createTreemap();
          break;
      }
    });
  },
  beforeDestroy() {
    console.log("Destroy Treemap!!!");
    this.unsubscribe();
  },
  updated() {},
  methods: {
    createTreemap: function () {
      this.treemap = new EvaluationChartTreemap(this.evaluation.children, this.alias);
    },
    setConventions(type){
      switch (type){
        case 'branch':
          this.conventions = [
            {
              label: 'label_evaluation_treemap_100',
              color: '#1E4381'
            },
            {
              label: 'label_evaluation_treemap_75',
              color: '#6f3996'
            },
            {
              label: 'label_evaluation_treemap_50',
              color: '#97cafc'
            },
            {
              label: 'label_evaluation_treemap_25',
              color: '#e9cafc'
            },
            {
              label: 'label_evaluation_treemap_pending',
              color: '#999999'
            }
          ]
          break;
        case 'leaf':
          this.conventions = [
            {
              label: 'label_evaluation_treemap_achieved',
              color: '#009355'
            },
            {
              label: 'label_evaluation_treemap_closeToBeAchieved',
              color: '#F96460'
            },
            {
              label: 'label_evaluation_treemap_partiallyAchieved',
              color: '#FFBE00'
            },
            {
              label: 'label_evaluation_treemap_notAchieved',
              color: '#e60246'
            },
            {
              label: 'label_evaluation_treemap_pending',
              color: '#999999'
            }
          ]
          break;
      }
    }
  },
};
</script>

<style lang="scss" scoped>

@import '../../../../assets/css/variables.scss';

.up {
  font: bold 14px/1 $font-subtitle;
  color: white;
  padding: 8px;
  background-color: $primary-color;
  float: left;
  cursor: pointer;
  &:hover {
    background-color: $secondary-accent;
  }
}
.feature {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0px;
  overflow: hidden;
}
.node {
  position: absolute;
  background: transparent no-repeat 50% / cover;
  overflow: hidden;
  opacity: 1;
  transition: opacity .8s;
  cursor: pointer;
  border: 1px solid #fff;
  .label {
    display: inline;
    font-size: 1rem;
    font-family: $font-subtitle;
    position: absolute;
    padding: 0;
    margin: 0;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    transition: color .4s, opacity .8s, filter .8s;
    width: 90%;
    text-align: center;
    p {
      margin-bottom: 0rem;
    }
    .index {
      font-size: 1.2rem !important;
    }
  }
  &.hide {
    opacity: 0;
    pointer-events: none;
    .label {
      filter: blur(10px);
    }
  }
  &:hover {
    .label {
      opacity: 1;
    }
  }
  &.level-0 {
    z-index: 4;
    font-size: 15vmin;
    display: none;
  }
  &.level-1 {
    z-index: 3;
    font-size: 10vmin;
  }
  &.level-2 {
    z-index: 2;
    font-size: 5vmin;
  }
  &.level-3 {
    z-index: 1;
    font-size: 2.5vmin;
  }
}
.title {
  text-align: center;
}
.convention-color {
  border-radius: 3px;
  display: inline-block;
  height: 20px;
  margin-right: 5px;
  position: relative;
  top: 5px;
  width: 20px;
}
.conventions{
  display: inline;
  .convention{
    display: inline;
    margin: 0 5px;
  }
}
.convention-container {
  display: flex;
  white-space: nowrap;
  flex-wrap: nowrap;
  min-width: 100%;
  max-width: 100%;
  width: 100%;
  align-items: baseline;
}
.convention-container > div {
  flex-basis: 0;
  flex-grow: 1;
  overflow: hidden;
}
.convention-title {
  text-align: center;
}
</style>
